import styled from 'styled-components'
import { Flex } from '../../new/core-components/box/Box'
import { Text } from '../../new/core-components/text/Text'

export const LabelStyled = styled.label`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  min-width: 0;
`
const translateUp = '-10px'
const translateDown = '10px'
export const FloatingTextStyled = styled(Flex)<{
  active: boolean
  isAbove: boolean
  textArea?: boolean
}>`
  transition: all 0.4s;
  transform: ${({ active, textArea, isAbove }) => {
    if (textArea) {
      return
    }
    if (!active) {
      if (isAbove) {
        return `translateY(${translateDown})`
      } else {
        return `translateY(${translateUp})`
      }
    }
  }};
`
export const TextAnimationStyled = styled(Text)`
  transition: all 0.4s;
`
